import React from 'react';
import { Button, Modal } from "react-bootstrap";

const UseMobile = () => {
    return (
        <>
        <Modal show={true} style={{marginTop:"250px"}}>
            <div className='UseMobileModal'>
                <p className='UseMobileModalp'>
                 برای دسترسی به اپی پخش لطفا از تلفن همراه خود استفاده کنید .
                </p>
                <button onClick={()=>window.location.href = "https://apipakhsh.ir/"} className='UseMobileModalbutton'>
                    تایید
                </button>
            </div>
        </Modal>
        </>
    );
};

export default UseMobile;